export const CREATE_USER  = 'CREATE_USER';
export const GET_USERS  = 'GET_USERS';
export const USER_REQUEST  = 'USER_REQUEST';
export const DELETE_USER  = 'DELETE_USER';
export const UPDATE_USER  = 'UPDATE_USER';
export const USER_REQUEST_FAILURE  = 'USER_REQUEST_FAILURE';